import { computed, watch } from '@vue/composition-api'

const PER_PAGE_OPTIONS = [20, 50, 100]

export default function usePublicDraws(proxy) {
  const state = computed(() => proxy.$store.state.publicDraws)
  const page = computed(() => {
    const value = Number(proxy.$route.query.page)
    return Number.isInteger(value) && value > 0 ? value : 1
  })
  const perPage = computed(() => {
    const value = Number(proxy.$route.query.per_page)
    return PER_PAGE_OPTIONS.includes(value) ? value : PER_PAGE_OPTIONS[0]
  })

  function changePage(value) {
    if (value === page.value) return
    proxy.$router.push({ query: { ...proxy.$route.query, page: String(value) } })
  }

  function changePerPage(value) {
    if (value === perPage.value) return
    proxy.$router.push({ query: { ...proxy.$route.query, page: '1', per_page: String(value) } })
  }

  watch(() => proxy.$route.params.eventId, (eventId) => {
    proxy.$store.dispatch('publicDraws/fetchInfo', eventId)
  }, { immediate: true })

  watch(() => [proxy.$route.params.eventId, proxy.$route.params.round, page.value, perPage.value], () => {
    proxy.$store.dispatch('publicDraws/fetch', {
      eventId: proxy.$route.params.eventId,
      round: Number(proxy.$route.params.round) || 1,
      page: page.value,
      perPage: perPage.value
    })
  }, { immediate: true })

  // A saved URL may point past the final page after runs have been removed.
  watch(() => state.value.meta, (meta) => {
    if (meta.last_page && page.value > meta.last_page) {
      proxy.$router.replace({ query: { ...proxy.$route.query, page: String(meta.last_page) } })
    }
  })

  return {
    eventName: computed(() => state.value.event.name || 'Draws'),
    rounds: computed(() => state.value.rounds),
    draws: computed(() => state.value.draws),
    loading: computed(() => state.value.loading || state.value.infoLoading),
    totalPages: computed(() => state.value.meta.last_page || 1),
    page,
    perPage,
    perPageOptions: PER_PAGE_OPTIONS,
    changePage,
    changePerPage
  }
}



// WEBPACK FOOTER //
// ./src/composables/draws/usePublicDraws.js